import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
const locations = [{
  name: 'Derbyshire',
  bookingHref: '/book/derbyshire',
  image: 'https://cdn.magicpatterns.com/uploads/m5Djz4X2GZCdJbYx3jLThf/Derbyshire_outline.png'
}, {
  name: 'Hampshire',
  bookingHref: '/book/hampshire',
  image: 'https://cdn.magicpatterns.com/uploads/u7EsSGoRknEHgTpFD6unBr/Hampshire_outline.png'
}, {
  name: 'Hertfordshire',
  bookingHref: '/book/hertfordshire',
  image: 'https://cdn.magicpatterns.com/uploads/rbdfoft5zZYRHVKy5gumeK/Hertfordshire_outline.png'
}];
export function BookNowPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white pt-20" data-id="element-726">
      {/* Hero */}
      <section className="relative overflow-hidden bg-brand-blue pt-28 pb-20 md:pt-36 md:pb-28 min-h-[320px] md:min-h-[400px]" data-id="element-727">
        <img src="https://cdn.magicpatterns.com/uploads/8m3ZDfLxFh7GqHfUAhVAku/Adults-Badminton-Photo-TK-LK-scaled-e1737371933423_(1).jpg" alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" data-id="element-728" />
        <div className="absolute inset-0 bg-brand-blue/85" data-id="element-729"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-730">
          <nav className="flex justify-center text-sm font-medium text-white/70 mb-8" data-id="element-731">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-732">
              Home
            </Link>
            <span className="mx-2" data-id="element-733">/</span>
            <span className="text-white" data-id="element-734">Book Now</span>
          </nav>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-white mb-4 leading-tight uppercase" data-id="element-735">
            Coaching Workshops and Sports Class Booking
          </h1>
          <p className="text-sm md:text-base tracking-[0.25em] uppercase text-white/70" data-id="element-736">
            Sports Coaching Led by Olympians
          </p>
        </div>
      </section>

      {/* Choose Your Location */}
      <section className="py-16 md:py-20 bg-gray-100" data-id="element-737">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-738">
          <h2 className="text-2xl md:text-3xl font-display font-bold text-navy-900 text-center mb-12 uppercase" data-id="element-739">
            Choose Your Location
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-740">
            {locations.map(location => <div key={location.name} className="bg-white rounded-lg overflow-hidden border-2 border-navy-200 text-center" data-id="element-741">
                {/* County outline map */}
                <div className="bg-[#335F91] aspect-square flex items-center justify-center p-10" data-id="element-742">
                  <img src={location.image} alt={`${location.name} county outline`} className="w-full h-full object-contain opacity-80" data-id="element-743" />
                </div>

                {/* Location info */}
                <div className="p-6" data-id="element-744">
                  <h3 className="text-xl font-display font-bold text-navy-900 uppercase mb-2" data-id="element-745">
                    {location.name}
                  </h3>
                  <p className="text-navy-600 text-sm mb-6" data-id="element-746">
                    Workshops &amp; Classes
                  </p>
                  <Button href={location.bookingHref} variant="primary" className="w-full" aria-label={`Book now for ${location.name}`} data-id="element-747">
                    Book Now
                  </Button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Contact Section */}
    </main>;
}